import { useNotification } from "../../../contexts/NotificationProvider";

const useNotificationStorageService = () => {

  async function saveNotificationModelCount(model: string, currentCount: number) {
    try {
      const newCount = model == "notification" ? currentCount : currentCount + 1;
      localStorage.setItem(model, newCount.toString())
      // await storage.save({
      //   key: model, // Note: Do not use underscore("_") in key!
      //   data: {
      //     count: newCount,
      //   },
      //   expires: 1000 * 3600 * 24,
      // });
  
    } catch (err) {
      console.error('Error saving new '+ model +' count:', err);
    }
  }

  async function updateNotificationModelCount(model: string, count: number) {
    try {
      localStorage.setItem(model, count.toString())
      // await ztorage.save({
      //   key: model, // Note: Do not use underscore("_") in key!
      //   data: {
      //     count: count,
      //   },
      //   expires: 1000 * 3600 * 24, // Définissez une expiration si nécessaire
      // });
    } catch (err) {
      console.error('Error saving new '+ model +' count:', err);
    }
  }

  async function getNotificationModelCount(model: string) {
    try {
      const ret_string = localStorage.getItem(model);
      const ret = ret_string ? parseInt(ret_string) : 0;
      // console.log('wow', model + ": "+ ret_string);
      return ret;
    } catch (err) {
      return 0;
    }
  }

  // storage for redirection
  async function saveNotificationModelLink(model: string, newLink: string, senderId?: string) {
    try {
      // console.log('ppp');
      // const currentCount = await getModelCount(model);
      // const newCount = model == "notification" ? currentCount : currentCount + 1;
      const data = {
        link: newLink,
        senderId: senderId ? senderId : "",
      }
      const serialized = JSON.stringify(data)
      localStorage.setItem(model, serialized);
  
    } catch (err) {
      console.error('Error saving new '+ model +' link:', err);
    }
  }

  async function updateNotificationModelLink(model: string, link: string, senderId?: string) {
    try {
      const data = {
        link,
        senderId: senderId ? senderId : "",
      }
      JSON.stringify(data)
      localStorage.setItem(model, data.toString());
    } catch (err) {
      console.error('Error saving new '+ model +' link:', err);
    }
  }

  async function getNotificationModelLink(model: string) {
    try {
      const ret_string = localStorage.getItem(model);
      const ret = ret_string ? JSON.parse(ret_string) : "";

      return ret?.link;
    } catch (err) {
      return "";
    }
  }

    return {
      saveNotificationModelCount, updateNotificationModelCount, getNotificationModelCount,
      saveNotificationModelLink, updateNotificationModelLink, getNotificationModelLink
    };
};

export default useNotificationStorageService;